// utils/MapHandlers.js

export const handleMapClick = (
  info,
  activeMode,
  wfsLayers,
  currentMeasureDrawing,
  setCurrentMeasureDrawing,
  handleMeasureDrawing,
  setLayerEPSG
) => {
  if (activeMode === 'measureArea' || activeMode === 'measureDistance' || activeMode === "regionOfInterest") {
    handleMeasureDrawing(info, currentMeasureDrawing, setCurrentMeasureDrawing, wfsLayers);
  }
  else if (info.layer) {
    const crs = info.layer.props.data?.crs?.properties?.name || "EPSG:8678";
    const epsgCode = crs.includes("EPSG:")
      ? crs.split("EPSG:").pop().replace(/^:/, "")
      : "8678";
    setLayerEPSG(`EPSG:${epsgCode}`);
  }
};